import { IlogisticServiceLocation, TlogisticType } from 'types/services';
import LogisticsOriginAndDestination from 'views/services/components/LogisticsServiceTrelloCard/Components/LogisticsOriginAndDestination/LogisticsOriginAndDestination';
import { BordOneToneIcon } from 'components/NudosComponents';
import { bordColorTheme } from 'styles/styles.constants';

import './LogisticServiceSummaryDetails.scss';

interface ILogisticServiceSummaryDetails {
  logisticType?: TlogisticType | null;
  origin?: IlogisticServiceLocation | null;
  destination?: IlogisticServiceLocation | null;
  manual?: boolean;
}

export const LogisticServiceSummaryDetails = ({
  manual,
  logisticType,
  origin,
  destination
}: ILogisticServiceSummaryDetails) => {
  return (
    <div className="logisticServiceSummaryDetails">
      <div className="flexLayout">
        {manual ? (
          <div className="flexLayout">
            <BordOneToneIcon variant="thumbsUp" stroke={bordColorTheme.navyBlue[900]} customWidth="14px" />
            <p className="p">Manual</p>
          </div>
        ) : (
          <div className="flexLayout">
            <BordOneToneIcon variant="refreshCcw" stroke={bordColorTheme.navyBlue[900]} customWidth="14px" />
            <p className="p">Automatizado</p>
          </div>
        )}
        <div className="divider"></div>
        <p className="logisticType p">{logisticType}</p>
      </div>
      <div className="logisticsOriginAndDestinationContainer">
        <LogisticsOriginAndDestination
          originIconViewBox="0 -0.5 16 17"
          destinationIconViewBox="0 -1 16 18"
          className="icons"
          origin={origin}
          destination={destination}
        />
      </div>
    </div>
  );
};
